// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_fK","seoBlockContent_visible":"c-a_fL"};